
import Header from '../../components/feature/Header';

export default function Services() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">服務項目</h1>
            <div className="w-24 h-1 bg-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600 text-lg">各類公共工程及民間建築工程</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <img 
                src="https://public.readdy.ai/ai/img_res/9b9bf07793cc33734322084da1e86f40.jpg"
                alt="公共工程"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-government-line text-blue-600 mr-2"></i>
                  公共工程
                </h3>
                <p className="text-gray-600 mb-4">承攬各類政府公共建設工程，包括學校、道路、橋樑等基礎設施建設。</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    學校建築工程
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    道路橋樑工程
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    公共設施建設
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <img 
                src="https://readdy.ai/api/search-image?query=Private%20residential%20building%20construction%20site%20with%20modern%20architecture%2C%20Taiwan%20housing%20development%2C%20construction%20workers%20building%20homes%2C%20clean%20construction%20environment&width=400&height=250&seq=private-construction&orientation=landscape"
                alt="民間建築工程"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-building-line text-blue-600 mr-2"></i>
                  民間建築工程
                </h3>
                <p className="text-gray-600 mb-4">提供民間住宅、商業建築等各類建築工程服務，品質優良。</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    住宅建築
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    商業建築
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    工業建築
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <img 
                src="https://readdy.ai/api/search-image?query=Civil%20engineering%20construction%20with%20complete%20excavator%20with%20mechanical%20arm%20and%20concrete%20work%2C%20Taiwan%20infrastructure%20development%2C%20road%20construction%20and%20drainage%20systems%2C%20professional%20engineering%20work%20with%20realistic%20heavy%20machinery&width=400&height=250&seq=civil-engineering-realistic&orientation=landscape"
                alt="土木工程"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-hammer-line text-blue-600 mr-2"></i>
                  土木工程
                </h3>
                <p className="text-gray-600 mb-4">專業土木工程施工，包括基礎工程、結構工程等各項土木建設。</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    基礎工程
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    結構工程
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    地下工程
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <img 
                src="https://readdy.ai/api/search-image?query=Drainage%20system%20construction%20with%20pipes%20and%20water%20management%20infrastructure%2C%20Taiwan%20water%20engineering%2C%20professional%20drainage%20installation%20work%2C%20clean%20construction%20site&width=400&height=250&seq=drainage-system&orientation=landscape"
                alt="區域排水"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-water-line text-blue-600 mr-2"></i>
                  區域排水
                </h3>
                <p className="text-gray-600 mb-4">專業排水系統設計與施工，確保區域排水功能完善。</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    排水管線工程
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    雨水下水道
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    防洪設施
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <img 
                src="https://readdy.ai/api/search-image?query=Interior%20renovation%20and%20decoration%20work%20with%20modern%20design%2C%20Taiwan%20interior%20construction%2C%20professional%20renovation%20team%20working%2C%20clean%20indoor%20construction%20environment&width=400&height=250&seq=interior-renovation&orientation=landscape"
                alt="室內裝修"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-home-line text-blue-600 mr-2"></i>
                  室內裝修
                </h3>
                <p className="text-gray-600 mb-4">提供專業室內裝修服務，打造舒適美觀的室內空間。</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    住宅裝修
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    辦公室裝修
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    商業空間裝修
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <img 
                src="https://readdy.ai/api/search-image?query=Road%20maintenance%20and%20repair%20work%20with%20construction%20equipment%2C%20Taiwan%20road%20infrastructure%2C%20professional%20road%20construction%20team%2C%20asphalt%20and%20concrete%20repair%20work&width=400&height=250&seq=road-maintenance&orientation=landscape"
                alt="道路維修"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 flex items-center">
                  <i className="ri-road-line text-blue-600 mr-2"></i>
                  道路維修
                </h3>
                <p className="text-gray-600 mb-4">專業道路維修與改善工程，確保道路安全與品質。</p>
                <ul className="space-y-2">
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    道路鋪設
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    路面修補
                  </li>
                  <li className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    農路改善
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-blue-600 text-white rounded-lg p-8">
              <h2 className="text-2xl font-bold mb-4">需要我們的服務嗎？</h2>
              <p className="text-blue-100 mb-6">歡迎聯絡我們，我們將為您提供專業的工程服務</p>
              <a 
                href="mailto:nero.nero@msa.hinet.net" 
                className="inline-flex items-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                立即聯絡我們
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
